import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectPageTitle } from 'features/pageTitle/pageTitleSelectors';

const PageTitle = () => {
  const title = useSelector(selectPageTitle);
  const { t } = useTranslation();

  useEffect(() => {
    document.title = title
      ? `${title} - ${t('common.label.joblioPortal')}`
      : t('common.label.joblioPortal');
  }, [title]);

  return <h1>{title}</h1>;
};

export default PageTitle;
